import type { Query as Query0 } from '../pages/check-in/[order]/pharmacy/search/list/index.page'
import type { Query as Query1 } from '../pages/check-in/[order]/pharmacy/search/map/index.page'
import type { OptionalQuery as OptionalQuery2 } from '../pages/home/index.page'
import type { Query as Query3 } from '../pages/home/clinics/index.page'
import type { OptionalQuery as OptionalQuery4 } from '../pages/home/register/index.page'
import type { OptionalQuery as OptionalQuery5 } from '../pages/home/register/complete/index.page'
import type { OptionalQuery as OptionalQuery6 } from '../pages/home/register/credit-card/index.page'
import type { OptionalQuery as OptionalQuery7 } from '../pages/home/register/id-document/index.page'
import type { OptionalQuery as OptionalQuery8 } from '../pages/home/register/profile/index.page'
import type { OptionalQuery as OptionalQuery9 } from '../pages/home/standby-groups/[standbyGroupId]/index.page'
import type { OptionalQuery as OptionalQuery10 } from '../pages/home/visit-groups/[visitGroupId]/index.page'
import type { Query as Query11 } from '../pages/home/visits/[visitId]/change-pharmacy/[pharmacyId]/questionnaire/index.page'
import type { Query as Query12 } from '../pages/home/visits/[visitId]/change-pharmacy/search/list/index.page'
import type { Query as Query13 } from '../pages/home/visits/[visitId]/change-pharmacy/search/map/index.page'
import type { OptionalQuery as OptionalQuery14 } from '../pages/reception/[clinicId]/index.page'

export const pagesPath = {
  "$404": {
    $url: (url?: { hash?: string }) => ({ pathname: '/404' as const, hash: url?.hash })
  },
  "campaign": {
    "amazon_gift": {
      $url: (url?: { hash?: string }) => ({ pathname: '/campaign/amazon-gift' as const, hash: url?.hash })
    }
  },
  "check_in": {
    _order: (order: string | number) => ({
      "fast_pass_reception": {
        "confirmation": {
          $url: (url?: { hash?: string }) => ({ pathname: '/check-in/[order]/fast-pass-reception/confirmation' as const, query: { order }, hash: url?.hash })
        }
      },
      "medicine_reception": {
        $url: (url?: { hash?: string }) => ({ pathname: '/check-in/[order]/medicine-reception' as const, query: { order }, hash: url?.hash })
      },
      "payment_method": {
        $url: (url?: { hash?: string }) => ({ pathname: '/check-in/[order]/payment-method' as const, query: { order }, hash: url?.hash })
      },
      "pharmacy": {
        _pharmacyId: (pharmacyId: string | number) => ({
          $url: (url?: { hash?: string }) => ({ pathname: '/check-in/[order]/pharmacy/[pharmacyId]' as const, query: { order, pharmacyId }, hash: url?.hash })
        }),
        "search": {
          "list": {
            $url: (url: { query: Query0, hash?: string }) => ({ pathname: '/check-in/[order]/pharmacy/search/list' as const, query: { order, ...url.query }, hash: url.hash })
          },
          "map": {
            $url: (url: { query: Query1, hash?: string }) => ({ pathname: '/check-in/[order]/pharmacy/search/map' as const, query: { order, ...url.query }, hash: url.hash })
          },
          "request": {
            $url: (url?: { hash?: string }) => ({ pathname: '/check-in/[order]/pharmacy/search/request' as const, query: { order }, hash: url?.hash })
          }
        },
        $url: (url?: { hash?: string }) => ({ pathname: '/check-in/[order]/pharmacy' as const, query: { order }, hash: url?.hash })
      },
      "questionnaire": {
        $url: (url?: { hash?: string }) => ({ pathname: '/check-in/[order]/questionnaire' as const, query: { order }, hash: url?.hash })
      },
      "reception": {
        "payment_method": {
          $url: (url?: { hash?: string }) => ({ pathname: '/check-in/[order]/reception/payment-method' as const, query: { order }, hash: url?.hash })
        }
      },
      $url: (url?: { hash?: string }) => ({ pathname: '/check-in/[order]' as const, query: { order }, hash: url?.hash })
    }),
    "select_profile": {
      $url: (url?: { hash?: string }) => ({ pathname: '/check-in/select-profile' as const, hash: url?.hash })
    }
  },
  "fast_pass_reception": {
    _clinicId: (clinicId: string | number) => ({
      "patients": {
        _patientId: (patientId: string | number) => ({
          $url: (url?: { hash?: string }) => ({ pathname: '/fast-pass-reception/[clinicId]/patients/[patientId]' as const, query: { clinicId, patientId }, hash: url?.hash })
        }),
        "new": {
          $url: (url?: { hash?: string }) => ({ pathname: '/fast-pass-reception/[clinicId]/patients/new' as const, query: { clinicId }, hash: url?.hash })
        }
      },
      "select_profile": {
        $url: (url?: { hash?: string }) => ({ pathname: '/fast-pass-reception/[clinicId]/select-profile' as const, query: { clinicId }, hash: url?.hash })
      },
      "select_time_slot": {
        $url: (url?: { hash?: string }) => ({ pathname: '/fast-pass-reception/[clinicId]/select-time-slot' as const, query: { clinicId }, hash: url?.hash })
      },
      "walk_in": {
        $url: (url?: { hash?: string }) => ({ pathname: '/fast-pass-reception/[clinicId]/walk-in' as const, query: { clinicId }, hash: url?.hash })
      },
      $url: (url?: { hash?: string }) => ({ pathname: '/fast-pass-reception/[clinicId]' as const, query: { clinicId }, hash: url?.hash })
    })
  },
  "home": {
    "clinics": {
      $url: (url: { query: Query3, hash?: string }) => ({ pathname: '/home/clinics' as const, query: url.query, hash: url.hash })
    },
    "histories": {
      $url: (url?: { hash?: string }) => ({ pathname: '/home/histories' as const, hash: url?.hash })
    },
    "patients": {
      _patientId: (patientId: string | number) => ({
        $url: (url?: { hash?: string }) => ({ pathname: '/home/patients/[patientId]' as const, query: { patientId }, hash: url?.hash })
      }),
      "new": {
        $url: (url?: { hash?: string }) => ({ pathname: '/home/patients/new' as const, hash: url?.hash })
      }
    },
    "register": {
      "complete": {
        $url: (url?: { query?: OptionalQuery5, hash?: string }) => ({ pathname: '/home/register/complete' as const, query: url?.query, hash: url?.hash })
      },
      "credit_card": {
        $url: (url?: { query?: OptionalQuery6, hash?: string }) => ({ pathname: '/home/register/credit-card' as const, query: url?.query, hash: url?.hash })
      },
      "id_document": {
        $url: (url?: { query?: OptionalQuery7, hash?: string }) => ({ pathname: '/home/register/id-document' as const, query: url?.query, hash: url?.hash })
      },
      "profile": {
        $url: (url?: { query?: OptionalQuery8, hash?: string }) => ({ pathname: '/home/register/profile' as const, query: url?.query, hash: url?.hash })
      },
      $url: (url?: { query?: OptionalQuery4, hash?: string }) => ({ pathname: '/home/register' as const, query: url?.query, hash: url?.hash })
    },
    "standby_groups": {
      _standbyGroupId: (standbyGroupId: string | number) => ({
        "cancelled": {
          $url: (url?: { hash?: string }) => ({ pathname: '/home/standby-groups/[standbyGroupId]/cancelled' as const, query: { standbyGroupId }, hash: url?.hash })
        },
        "guest": {
          "expired": {
            $url: (url?: { hash?: string }) => ({ pathname: '/home/standby-groups/[standbyGroupId]/guest/expired' as const, query: { standbyGroupId }, hash: url?.hash })
          },
          $url: (url?: { hash?: string }) => ({ pathname: '/home/standby-groups/[standbyGroupId]/guest' as const, query: { standbyGroupId }, hash: url?.hash })
        },
        "patients": {
          _patientId: (patientId: string | number) => ({
            $url: (url?: { hash?: string }) => ({ pathname: '/home/standby-groups/[standbyGroupId]/patients/[patientId]' as const, query: { standbyGroupId, patientId }, hash: url?.hash })
          }),
          "new": {
            $url: (url?: { hash?: string }) => ({ pathname: '/home/standby-groups/[standbyGroupId]/patients/new' as const, query: { standbyGroupId }, hash: url?.hash })
          }
        },
        "profile": {
          $url: (url?: { hash?: string }) => ({ pathname: '/home/standby-groups/[standbyGroupId]/profile' as const, query: { standbyGroupId }, hash: url?.hash })
        },
        "select_menu": {
          _order: (order: string | number) => ({
            $url: (url?: { hash?: string }) => ({ pathname: '/home/standby-groups/[standbyGroupId]/select-menu/[order]' as const, query: { standbyGroupId, order }, hash: url?.hash })
          })
        },
        "select_profile": {
          $url: (url?: { hash?: string }) => ({ pathname: '/home/standby-groups/[standbyGroupId]/select-profile' as const, query: { standbyGroupId }, hash: url?.hash })
        },
        $url: (url?: { query?: OptionalQuery9, hash?: string }) => ({ pathname: '/home/standby-groups/[standbyGroupId]' as const, query: { standbyGroupId, ...url?.query }, hash: url?.hash })
      })
    },
    "standbys": {
      _standbyId: (standbyId: string | number) => ({
        $url: (url?: { hash?: string }) => ({ pathname: '/home/standbys/[standbyId]' as const, query: { standbyId }, hash: url?.hash })
      })
    },
    "visit_groups": {
      _visitGroupId: (visitGroupId: string | number) => ({
        "cancelled": {
          $url: (url?: { hash?: string }) => ({ pathname: '/home/visit-groups/[visitGroupId]/cancelled' as const, query: { visitGroupId }, hash: url?.hash })
        },
        $url: (url?: { query?: OptionalQuery10, hash?: string }) => ({ pathname: '/home/visit-groups/[visitGroupId]' as const, query: { visitGroupId, ...url?.query }, hash: url?.hash })
      })
    },
    "visits": {
      _visitId: (visitId: string | number) => ({
        "change_payment_method": {
          "temporary_unavailable": {
            $url: (url?: { hash?: string }) => ({ pathname: '/home/visits/[visitId]/change-payment-method/temporary-unavailable' as const, query: { visitId }, hash: url?.hash })
          },
          $url: (url?: { hash?: string }) => ({ pathname: '/home/visits/[visitId]/change-payment-method' as const, query: { visitId }, hash: url?.hash })
        },
        "change_pharmacy": {
          _pharmacyId: (pharmacyId: string | number) => ({
            "questionnaire": {
              $url: (url: { query: Query11, hash?: string }) => ({ pathname: '/home/visits/[visitId]/change-pharmacy/[pharmacyId]/questionnaire' as const, query: { visitId, pharmacyId, ...url.query }, hash: url.hash })
            },
            $url: (url?: { hash?: string }) => ({ pathname: '/home/visits/[visitId]/change-pharmacy/[pharmacyId]' as const, query: { visitId, pharmacyId }, hash: url?.hash })
          }),
          "search": {
            "list": {
              $url: (url: { query: Query12, hash?: string }) => ({ pathname: '/home/visits/[visitId]/change-pharmacy/search/list' as const, query: { visitId, ...url.query }, hash: url.hash })
            },
            "map": {
              $url: (url: { query: Query13, hash?: string }) => ({ pathname: '/home/visits/[visitId]/change-pharmacy/search/map' as const, query: { visitId, ...url.query }, hash: url.hash })
            },
            "request": {
              $url: (url?: { hash?: string }) => ({ pathname: '/home/visits/[visitId]/change-pharmacy/search/request' as const, query: { visitId }, hash: url?.hash })
            }
          }
        },
        "pharmacy": {
          $url: (url?: { hash?: string }) => ({ pathname: '/home/visits/[visitId]/pharmacy' as const, query: { visitId }, hash: url?.hash })
        },
        "prescription": {
          "error": {
            $url: (url?: { hash?: string }) => ({ pathname: '/home/visits/[visitId]/prescription/error' as const, query: { visitId }, hash: url?.hash })
          },
          $url: (url?: { hash?: string }) => ({ pathname: '/home/visits/[visitId]/prescription' as const, query: { visitId }, hash: url?.hash })
        },
        "questionnaire": {
          $url: (url?: { hash?: string }) => ({ pathname: '/home/visits/[visitId]/questionnaire' as const, query: { visitId }, hash: url?.hash })
        },
        $url: (url?: { hash?: string }) => ({ pathname: '/home/visits/[visitId]' as const, query: { visitId }, hash: url?.hash })
      })
    },
    $url: (url?: { query?: OptionalQuery2, hash?: string }) => ({ pathname: '/home' as const, query: url?.query, hash: url?.hash })
  },
  "qr": {
    _qrCode: (qrCode: string | number) => ({
      "connect": {
        $url: (url?: { hash?: string }) => ({ pathname: '/qr/[qrCode]/connect' as const, query: { qrCode }, hash: url?.hash })
      }
    }),
    "check_in": {
      _qrCode: (qrCode: string | number) => ({
        $url: (url?: { hash?: string }) => ({ pathname: '/qr/check-in/[qrCode]' as const, query: { qrCode }, hash: url?.hash })
      })
    }
  },
  "reception": {
    _clinicId: (clinicId: string | number) => ({
      "patients": {
        _patientId: (patientId: string | number) => ({
          $url: (url?: { hash?: string }) => ({ pathname: '/reception/[clinicId]/patients/[patientId]' as const, query: { clinicId, patientId }, hash: url?.hash })
        }),
        "new": {
          $url: (url?: { hash?: string }) => ({ pathname: '/reception/[clinicId]/patients/new' as const, query: { clinicId }, hash: url?.hash })
        }
      },
      "profile": {
        $url: (url?: { hash?: string }) => ({ pathname: '/reception/[clinicId]/profile' as const, query: { clinicId }, hash: url?.hash })
      },
      "select_menu": {
        _order: (order: string | number) => ({
          $url: (url?: { hash?: string }) => ({ pathname: '/reception/[clinicId]/select-menu/[order]' as const, query: { clinicId, order }, hash: url?.hash })
        })
      },
      "select_profile": {
        $url: (url?: { hash?: string }) => ({ pathname: '/reception/[clinicId]/select-profile' as const, query: { clinicId }, hash: url?.hash })
      },
      "status": {
        $url: (url?: { hash?: string }) => ({ pathname: '/reception/[clinicId]/status' as const, query: { clinicId }, hash: url?.hash })
      },
      $url: (url?: { query?: OptionalQuery14, hash?: string }) => ({ pathname: '/reception/[clinicId]' as const, query: { clinicId, ...url?.query }, hash: url?.hash })
    })
  },
  $url: (url?: { hash?: string }) => ({ pathname: '/' as const, hash: url?.hash })
}

export type PagesPath = typeof pagesPath
